import { cn } from '@/lib/utils'

export const ProductNfrFlag = () => (
  <div
    className={cn(
      'absolute z-10 mt-1 ml-1 flex w-13.25 items-center justify-center rounded bg-[#FFBB9266] py-1 lg:mt-3 lg:ml-3',
    )}
    data-test="nfr-sticker"
  >
    <p className="text-center text-[0.6rem] font-semibold text-[#D77512] sm:text-sm">
      NFR
    </p>
  </div>
)
